import { ForaLogo, ArenaCateringLogo } from "./ForaLogo";

export const Header = ({ language, setLanguage }) => {
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#e8e8e8] px-4 py-3 flex justify-between items-center"
    >
      <div className="flex items-center gap-3">
        <ForaLogo height="h-6" />
        <div className="w-px h-5 bg-[#e8e8e8]" />
        <ArenaCateringLogo height="h-6" />
      </div>
      <div
        data-testid="language-toggle"
        className="flex items-center space-x-1 bg-[#e8e8e8] rounded-full p-1"
      >
        <button
          data-testid="lang-en-btn"
          onClick={() => setLanguage("en")}
          className={`px-3 py-1 text-sm font-bold rounded-full transition-all ${
            language === "en"
              ? "bg-white text-[#000000] shadow-sm"
              : "text-gray-500 hover:text-[#000000]"
          }`}
        >
          EN
        </button>
        <button
          data-testid="lang-pl-btn"
          onClick={() => setLanguage("pl")}
          className={`px-3 py-1 text-sm font-bold rounded-full transition-all ${
            language === "pl"
              ? "bg-white text-[#000000] shadow-sm"
              : "text-gray-500 hover:text-[#000000]"
          }`}
        >
          PL
        </button>
      </div>
    </header>
  );
};
